import React, { useState, useEffect } from 'react';
import { FormControl, Box, Select, MenuItem, InputLabel } from '@mui/material';
import { default as MUIColorPicker } from 'mui-color-picker';
import { colorPickerStyle, SelectChangeEvent } from './color-picker-helper';

interface DataItem {
    checked: boolean;
    colorCode: string;
    id: number;
    variableName: string;
}

interface ColourPickerProps {
    onChange: Function;
    presetColors: DataItem[];
    value: string;
}

export const ColorPicker = ({
    onChange,
    presetColors,
    value,
}: ColourPickerProps): React.JSX.Element => {
    const [colorInput, setColorInput] = useState<string>('');
    const [selectedColor, setSelectedColor] = useState<string>('');

    useEffect(() => {
        if (value) {
            setColorInput(value);
            setSelectedColor(value);
        }
    }, [value]);

    const handleColorChange = (color: string): void => {
        setSelectedColor(color);
        setColorInput(color);
        onChange(color);
    };
    const handleSelect = (e: SelectChangeEvent): void => {
        setColorInput('');
        setSelectedColor(e.target.value);
        onChange(e.target.value);
    };
    return (
        <Box sx={colorPickerStyle.colorContainer}>
            <Box>
                <FormControl sx={colorPickerStyle.formStyle}>
                    <InputLabel id='color-select-label'>
                        Select Color
                    </InputLabel>
                    <Select
                        labelId='color-select-label'
                        MenuProps={{
                            anchorOrigin: {
                                vertical: 'top',
                                horizontal: 'left',
                            },
                            transformOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                            },
                        }}
                        value={selectedColor ?? colorInput}
                        onChange={(e: SelectChangeEvent): void =>
                            handleSelect(e)
                        }
                        label='Select Color'
                    >
                        {presetColors.map((name: DataItem) => (
                            <MenuItem
                                key={name.colorCode}
                                value={name.colorCode}
                            >
                                <div
                                    style={
                                        colorPickerStyle.colorPickerSwatchItems
                                    }
                                >
                                    <div
                                        style={{
                                            ...colorPickerStyle.colorSwatch,
                                            backgroundColor: name.colorCode,
                                        }}
                                    ></div>
                                    <span
                                        style={colorPickerStyle.colorMenuItem}
                                    >
                                        {name.colorCode}
                                    </span>
                                </div>
                            </MenuItem>
                        ))}{' '}
                        <MenuItem value={colorInput}>
                            <div
                                style={colorPickerStyle.colorPickerSwatchItems}
                            >
                                <div
                                    style={{
                                        ...colorPickerStyle.colorSwatch,
                                        backgroundColor: colorInput,
                                    }}
                                ></div>
                                <span style={colorPickerStyle.colorMenuItem}>
                                    {colorInput}
                                </span>
                            </div>
                        </MenuItem>
                    </Select>
                </FormControl>
            </Box>
            <Box sx={colorPickerStyle.colorPickerSwatchItems}>
                <Box sx={colorPickerStyle.colorPicker}>
                    <MUIColorPicker
                        name='color-picker'
                        value={colorInput}
                        onChange={(color: string): void =>
                            handleColorChange(color)
                        }
                        sx={{
                            fieldset: colorPickerStyle.colorPickerFieldSet,
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
};
